import React, { useState, useRef, useEffect } from 'react'
import { useTheme } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import CardContent from '@mui/material/CardContent'

import TextField from '@mui/material/TextField'
import useMediaQuery from '@mui/material/useMediaQuery'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Typography from '@mui/material/Typography'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import { useParams } from 'react-router-dom'
import TokTokDocDialog from '../Common/Dialog'
import TokTokDocTextField from '../Common/TextField'
import styles from './userPasswordStyles'
import { forceUserPassword, getUserSensitiveData } from '../../api/user'
import { isPasswordValid } from '../../utils/validators'
import { isEmailReal } from '../../utils/formUtils'
import { displaySnackbar } from '../../actions/main'
import { RouterRouteId } from '../../routers/_props'
import { useAppDispatch } from '../../store'
import useUserPermissions from '../../hooks/useUserPermissions'
import useCurrentHcs from '../../hooks/useCurrentHcs'

// @ts-expect-error TS(2345) FIXME: Argument of type '(theme: any) => { firstRow: { pa... Remove this comment to see the full error message
const useStyles = makeStyles(styles)

export default function Paswword() {
    const theme = useTheme()
    const dispatch = useAppDispatch()
    const classes = useStyles()
    const isLarge = useMediaQuery(theme.breakpoints.between('md', 'xl'))
    const { id: hcsId } = useCurrentHcs()
    const { id } = useParams<RouterRouteId>()
    const { hasUserPermission } = useUserPermissions()
    const canForcePassword = hasUserPermission('ADMIN') || hasUserPermission('SUPER ADMIN')
    const [openConfirm, setOpenConfirm] = useState(false)
    const [loading, setLoading] = useState(false)
    const [email, setEmail] = useState('')
    const [privatePhone, setPrivatePhone] = useState('')
    const password = useRef()
    const repeatedPassword = useRef()

    useEffect(() => {
        getUserSensitiveData(id).then((data) => {
            setEmail(data.email)
            setPrivatePhone(data.privatePhone)
        })
    }, [id])

    const forcePassword = (pwd = '') => {
        setOpenConfirm(false)
        setLoading(true)
        forceUserPassword(hcsId, id, pwd)
            .then(() => {
                dispatch(
                    displaySnackbar(
                        'success',
                        'Mot de passe mis à jour.',
                        undefined,
                        `[Password] password update user ${id}`,
                    ),
                )
                setLoading(false)
            })
            .catch((error) => {
                dispatch(displaySnackbar('error', error.message))
                setLoading(false)
            })
            .finally(() => {
                // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                password.current.value = ''
                // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                repeatedPassword.current.value = ''
            })
    }

    const isRepeatedPasswordValid = (value: string) => {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        if (value !== password.current.value) {
            return 'Les mots de passes sont différents'
        }

        return true
    }

    const submitForcePassword = () => {
        if (
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            isRepeatedPasswordValid(repeatedPassword.current.value) === true &&
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            isPasswordValid(password.current.value) === true
        ) {
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            forcePassword(password.current.value)
        }
    }

    return (
        <Paper className={classes.paper}>
            <Card>
                <CardHeader title="Modifier un mot de passe" />
                <CardContent>
                    <Grid container direction="column">
                        <Grid item xs={12} className={classes.firstRow}>
                            <Grid container justifyContent="space-between" spacing={isLarge ? 10 : 1}>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="standard"
                                        className={classes.gridItemContent}
                                        id="email"
                                        label="Courriel"
                                        value={email}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        variant="standard"
                                        className={classes.gridItemContent}
                                        id="phone"
                                        label="Numéro personnel"
                                        value={privatePhone}
                                        disabled
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container spacing={2} direction="column">
                                <Grid item xs={12}>
                                    {isEmailReal(email) && (
                                        <Accordion elevation={2}>
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                <Typography variant="h3"> Réinitialiser le mot de passe </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Grid container spacing={4} justifyContent="flex-start" wrap="nowrap">
                                                    <Grid item xs={1}>
                                                        <InfoOutlinedIcon color="secondary" />
                                                    </Grid>
                                                    <Grid item xs={10}>
                                                        <Grid container spacing={6} direction="column">
                                                            <Grid item xs={12}>
                                                                <Typography variant="h4">
                                                                    {' '}
                                                                    Réinitialiser le mot de passe de l'utilisateur
                                                                    consiste à générer un nouveau mot de passe aléatoire
                                                                    pour l'utilisateur et à lui envoyer par email et/ou
                                                                    sms.{' '}
                                                                </Typography>
                                                                <Typography variant="h4">
                                                                    {' '}
                                                                    Ce mot de passe devra être modifié dès la prochaine
                                                                    connexion de l'utilisateur (il ne pourra effectuer
                                                                    aucune autre action).{' '}
                                                                </Typography>
                                                                <Typography variant="h4">
                                                                    {' '}
                                                                    L'utilisateur ne pourra plus se connecter tant qu'il
                                                                    n'aura pas choisi un nouveau mot de passe.{' '}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Grid container justifyContent="flex-end">
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        className={classes.button}
                                                                        onClick={() => setOpenConfirm(true)}
                                                                        disabled={loading}
                                                                    >
                                                                        RÉINITIALISER LE MOT DE PASSE
                                                                    </Button>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={1} />
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                    )}
                                </Grid>
                                {canForcePassword && (
                                    <Grid item xs={12}>
                                        <Accordion elevation={2}>
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                <Typography variant="h3"> Forcer le mot de passe </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Grid container spacing={4} justifyContent="flex-start" wrap="nowrap">
                                                    <Grid item xs={1}>
                                                        <InfoOutlinedIcon color="secondary" />
                                                    </Grid>
                                                    <Grid item xs={10}>
                                                        <Grid container spacing={6} direction="column">
                                                            <Grid item xs={12}>
                                                                <Grid container spacing={2}>
                                                                    <Grid item xs={12} md={12} lg={6}>
                                                                        <Typography variant="h4">
                                                                            {' '}
                                                                            Forcer le mot de passe de l'utilisateur
                                                                            consiste à choisir pour l'utilisateur un
                                                                            nouveau mot de passe temporaire (ce mot de
                                                                            passe devra tout de même suivre les règles
                                                                            standards).{' '}
                                                                        </Typography>
                                                                        <Typography variant="h4">
                                                                            {' '}
                                                                            Ce mot de passe devra être modifié dès la
                                                                            prochaine connexion de l'utilisateur (il ne
                                                                            pourra effectuer aucune autre action).{' '}
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={12} lg={1} />
                                                                    <Grid item xs={12} md={12} lg={5}>
                                                                        <Grid container spacing={1} direction="column">
                                                                            <Grid item>
                                                                                <TokTokDocTextField
                                                                                    disabled={!canForcePassword}
                                                                                    className={classes.gridItemContent}
                                                                                    inputRef={password}
                                                                                    id="password1"
                                                                                    type="password"
                                                                                    label="Nouveau mot de passe"
                                                                                    style={{
                                                                                        marginTop: '-11px',
                                                                                    }}
                                                                                    defaultValue=""
                                                                                    validator={isPasswordValid}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item>
                                                                                <TokTokDocTextField
                                                                                    disabled={!canForcePassword}
                                                                                    className={classes.gridItemContent}
                                                                                    inputRef={repeatedPassword}
                                                                                    id="password2"
                                                                                    type="password"
                                                                                    label="Confirmation du mot de passe"
                                                                                    defaultValue=""
                                                                                    validator={isRepeatedPasswordValid}
                                                                                />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Grid container justifyContent="flex-end">
                                                                    {/* @ts-expect-error TS(2769): No overload matches this call. */}
                                                                    <Button
                                                                        disabled={!canForcePassword || loading}
                                                                        variant="contained"
                                                                        color="primary"
                                                                        elevation={0}
                                                                        className={classes.button}
                                                                        onClick={submitForcePassword}
                                                                    >
                                                                        FORCER LE MOT DE PASSE
                                                                    </Button>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={1} />
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            <TokTokDocDialog
                isOpen={openConfirm}
                handleClose={() => setOpenConfirm(false)}
                handleSave={() => forcePassword()}
                saveTitle="Confirmer"
                title="Réinitialiser le mot de passe"
            >
                <Grid container>
                    <Grid item>
                        <Typography variant="h4">
                            Voulez-vous vraiment réinitialiser le mot de passe de cet utilisateur ?
                        </Typography>
                    </Grid>
                </Grid>
            </TokTokDocDialog>
        </Paper>
    )
}
